import '.c1{flex-shrink:0;}.ssr-plugin'
import '.c2{padding:1rem;}.ssr-plugin'
import '.a5{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.b5{border:none;}.ssr-plugin'
import '.b6{background-color:transparent;}.ssr-plugin'
import '.fa{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.dk{position:sticky;}.ssr-plugin'
import '.fb{top:4rem;}.ssr-plugin'
import '.fc{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.fd{padding-bottom:1rem;}.ssr-plugin'
import '.x{margin-bottom:1rem;}.ssr-plugin'
import '.fe{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a2{position:fixed;}.ssr-plugin'
import '.cy{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.ff{bottom:0px;}.ssr-plugin'
import '.dh{z-index:9999;}.ssr-plugin'
import '.fg{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cw{justify-content:flex-end;}.ssr-plugin'
import '.c3{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="c1 c2 a5 bk b5 b6 fa"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ab"
    >
      <div className="dk fb fc ae fd x fe a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a2 cy bi bj ff dh ae fg a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="c2 a cw fe"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="c3 at">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
